import { render, staticRenderFns } from "./SupplierScoring.vue?vue&type=template&id=1986c786&scoped=true&"
import script from "./SupplierScoring.vue?vue&type=script&lang=js&"
export * from "./SupplierScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986c786",
  null
  
)

export default component.exports